module.exports = [{"key":"1","name":"类型","data":[{"key":"1","name":"移动建模"},{"key":"2","name":"表单建模"},{"key":"3","name":"知识管理"},{"key":"4","name":"..."}]}]


//////////////////
// WEBPACK FOOTER
// ./src/mocks/screen_other.json
// module id = 530
// module chunks = 0